export const experiences = [
  {
    id: 1,
    title: "Statistical Mechanics TA",
    organization: "Minerva University",
    date: "Jan 2026 – Apr 2026",
    side: "left",
  },
  {
    id: 2,
    title: "Policy Intern",
    organization: "Tenderloin Community Benefit District",
    date: "Jan 2026 – Apr 2026",
    side: "right",
  },
  {
    id: 3,
    title: "Data Science Intern",
    organization: "City & County of San Francisco, District 5",
    date: "Sep 2025 – Dec 2025",
    side: "left",
  },
  {
    id: 4,
    title: "AI Intern",
    organization: "Minerva University, Graduate Programs",
    date: "Jun 2025 – Aug 2025",
    side: "right",
  },
  {
    id: 5,
    title: "Quantum Mechanics TA",
    organization: "Minerva University",
    date: "Sep 2024 – Dec 2025",
    side: "left",
  },
  {
    id: 6,
    title: "ML Research Assistant",
    organization: "Fermilab / UChicago Data Science Institute",
    date: "Jun 2024 – Dec 2024",
    side: "right",
  },
  {
    id: 7,
    title: "Data Science Intern",
    organization: "Minerva University",
    date: "May 2024 – Jul 2024",
    side: "left",
  },
  {
    id: 8,
    title: "Class of 2026 Representative",
    organization: "Minerva University Student Government",
    date: "Feb 2024 – Jan 2025",
    side: "right",
  },
  {
    id: 9,
    title: "ML Research Assistant",
    organization: "Seoul National University",
    date: "Sep 2023 – Dec 2023",
    side: "left",
  },
];
